import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core'
import { Platform, LoadingController } from '@ionic/angular';
import {GeneralServices} from '../../services/generalServices';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CrearNotasEnfermeriaService } from  './crear-notas-enfermeria.services';

@Component({
  selector: 'app-crear-notas-enfermeria',
  templateUrl: './crear-notas-enfermeria.page.html',
  styleUrls: ['./crear-notas-enfermeria.page.scss'],
  providers:[TranslateService, GeneralServices, CrearNotasEnfermeriaService]
})
export class CrearNotasEnfermeriaPage implements OnInit {
  
  public Enfermera: string = sessionStorage.getItem('dataUser')
  public CodigoEnfermeria: string;
  public Estudio: number;
  public modal;
  public parentClass;

  public forma: FormGroup;

  public Fecha = '';
  public Hora = '';
  public NotaEnfermeria = '';
  public TensionArterialAlta = '';
  public TensionArterialBaja = '';
  public FrecuenciaCardiaca = '';
  public FrecuenciaRespiratoria = '';
  public Peso = '';
  public Temperatura = '';
  public SaturacionOxigeno = '';
  public NotaEnfermeriaCerrada = false;
  public Glucometria  = '';
  
  constructor(private platform: Platform, 
    private translate: TranslateService, 
    private _generalServices:GeneralServices,
    private loadingCtrl: LoadingController,
    private route: ActivatedRoute,
    private router: Router,
    private _crearNotasEnfermeriaService: CrearNotasEnfermeriaService) {
     
      this.route
      .queryParams
      .subscribe(params => {
        this.Estudio = params['Estudio'];
        }
      )

     
    this._generalServices.setLanguage(this.translate);
   }

  ngOnInit() {
  }

  crearNotaEnfermeria(){
    let datauUser = JSON.parse(sessionStorage.getItem('dataUser'));
    
    let parametros = {

      'Ingreso': this.Estudio,
      'Fecha': this.Fecha,
      'Hora': this._generalServices.getFormatedTime(this.Hora),
      'Resumen': this.NotaEnfermeria,
      'Enfermera': datauUser[0].Nombre,
      'CodigoEnfermeria': datauUser[0].IdUsuario,
      'Ta': this.TensionArterialAlta+ "/" + this.TensionArterialBaja,
      'Fc': this.FrecuenciaCardiaca,
      'Fr': this.FrecuenciaRespiratoria,
      'Ps': this.Peso,
      'Tp': this.Temperatura,
      'O2': this.SaturacionOxigeno,
      'Cerrada': this.NotaEnfermeriaCerrada,
      'Glucometria': this.Glucometria
    };

    this._crearNotasEnfermeriaService.guardarNotaEnfermeria(parametros).subscribe(
      result => {
        this.modal.dismiss();
        this.parentClass.cargarListadoNotasEnfermeria();
        this._generalServices.toastNotify("Se ha guardado la nota correctamente.","success");
      },
      error =>{
        //console.log(error.error)
        this._generalServices.errorManager(error.error,'',true);
      }
    );
/*
    this._peticionService.post("GuardarNotaEnfermeria", parametros).subscribe(
      result => {
        if(!result["TieneErrores"]){
          this.presentAlert();
         // this.navCtrl.push(DetalleNotasEnfermeriaPage, {Estudio : this.Estudio});  
        }else{
          this._generalServices.errorManager(result["Errores"],'',true);
        }
      },
      error =>{
        this._generalServices.errorManager("Ocurrio un error al crear la nota de enfermeria",'',true);
      }
    );    */
  }

  presentAlert() {
    alert(".: Se creo la nota de enfermeria exitosamente");
    /*
    let alert = this._alertCtrl.create({
      title: 'Nota de enfermeria',
      subTitle: 'Se creo la nota de enfermeria exitosamente',
      buttons: ['Aceptar']
    });
    alert.present();*/
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CrearNotasEnfermeriaPage');
  }


  closeModal(){
    this.modal.dismiss();
  }

}
